"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zodToRightsholderModelMapper = exports.rightsholderModelToZodMapper = void 0;
const flatten_object_1 = require("@App/helpers/flatten-object");
const rightsholderModelToZodMapper = (rightsholderModel) => {
    const { phoneCountryCode, phoneAreaCode, phoneNumber } = rightsholderModel, withoutPhone = __rest(rightsholderModel, ["phoneCountryCode", "phoneAreaCode", "phoneNumber"]);
    const { city, state, postalCode, country } = withoutPhone, withoutPhoneAddress = __rest(withoutPhone, ["city", "state", "postalCode", "country"]);
    const { address2, address3, address4 } = withoutPhoneAddress, withoutExtendedAddress = __rest(withoutPhoneAddress, ["address2", "address3", "address4"]);
    const phoneNumberForm = {
        phoneCountryCode: phoneCountryCode ? String(phoneCountryCode) : '',
        phoneAreaCode: phoneAreaCode,
        phoneNumber,
    };
    const extendedAddressForm = {
        address2,
        address3,
        address4,
        city,
        state,
        postalCode,
        countryId: country ? String(country) : '',
    };
    return Object.assign(Object.assign({}, withoutExtendedAddress), { phoneNumber: phoneNumberForm, extendedAddressForm });
};
exports.rightsholderModelToZodMapper = rightsholderModelToZodMapper;
const zodToRightsholderModelMapper = (rightsholderZodObj) => {
    const withoutPermissions = __rest(rightsholderZodObj, []);
    const rightsholderModel = (0, flatten_object_1.flattenObject)(withoutPermissions);
    rightsholderModel.country = Number(rightsholderZodObj.extendedAddressForm.countryId);
    rightsholderModel.phoneCountryCode = Number(rightsholderZodObj.phoneNumber.phoneCountryCode);
    rightsholderModel.validationStatus = 'Done';
    return rightsholderModel;
};
exports.zodToRightsholderModelMapper = zodToRightsholderModelMapper;
